import React from 'react';

import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import DashboardSection from 'components/DashboardSection/DashboardSection';
import InvoicesTable from 'components/InvoicesTable/InvoicesTable';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import AddPaymentMethodButton from 'components/PaymentMethods/AddPaymentMethodButton';
import PaymentMethodDisplay from 'components/PaymentMethods/PaymentMethodDisplay';
import { useUserInfoContext } from 'components/UserInfoProvider/UserInfoProvider';

import { getUserInvoices } from 'utils/api';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  spacer: {
    marginTop: '40px',
  },
}));

const UserBillingPage = () => {
  const classes = useStyles();
  const { userInfo } = useUserInfoContext();

  const [invoices, setInvoices] = React.useState(undefined);

  React.useEffect(() => {
    (async () => {
      const { invoices: invoicesReturned } = await getUserInvoices();

      setInvoices(invoicesReturned);
    })();
  }, []);

  if (!userInfo) {
    return (<LoadingIndicator />);
  }

  return (
    <div className={classes.root}>
      <DashboardSection sectionName="Billing" />

      <Box style={{ height: '20px' }} />

      <AddPaymentMethodButton />

      <Box
        style={{ marginTop: '30px', marginBottom: '20px', gap: '20px' }}
        display="flex"
        flexDirection="row"
        flexWrap="wrap"
      >

        {userInfo.agentInfo.stripe.paymentMethods.map((paymentMethod) => (
          <PaymentMethodDisplay
            key={paymentMethod.id}
            paymentMethodId={paymentMethod.id}
            brand={paymentMethod.brand}
            last4={paymentMethod.last4}
            expMonth={paymentMethod.expMonth}
            expYear={paymentMethod.expYear}
            isDefault={paymentMethod.isDefault}
          />
        ))}
      </Box>

      <div className={classes.spacer} />

      <DashboardSection sectionName="Invoices" />
      <InvoicesTable invoices={invoices} />
    </div>
  );
};

export default UserBillingPage;
